module.exports = __webpack_public_path__ + "static/media/how_to_count.c1308262.png";